// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1QAxK","overflowing":"ReadFullNote_overflowing__2hMW-"};